export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.treasure.money";

/** Keep Play Console store listing Website set to https://treasuremoney.in */
